'use client';

import { PropsWithChildren } from 'react';
import { createIntl, createIntlCache, RawIntlProvider } from 'react-intl';

const cache = createIntlCache();

const IntlProvider = ({
	children,
	locale = 'en',
	messages,
}: PropsWithChildren<{
	locale: string;
	messages: Record<string, string>;
}>) => {
	const intl = createIntl(
		{
			locale,
			messages,
		},
		cache,
	);

	return <RawIntlProvider value={intl}>{children}</RawIntlProvider>;
};

export default IntlProvider;
